import React, { useState, useEffect } from 'react';
import { Collapse, Grid, IconButton, Typography, styled } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const CollapseContent = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '10px',
  marginBottom: '8px',
});

const StyledButtonGrid = styled(Grid)({
  cursor: 'pointer',
  paddingBlock: 0,
  paddingInline: 0,
  textAlign: 'initial',
  textRendering: 'initial',
  letterSpacing: 'initial',
  wordSpacing: 'initial',
  border: 'none',
  background: 'none',
  '&:focus': {
    outline: 'none',
    outlineOffset: 'none',
  },
});

export const FilterCollapsable = ({
  label,
  children,
  alreadyOpen,
  hideWrapper = false,
  collapseStyle = {},
  labelGridXs = 6,
  arrowGridXs = 6,
  idBase = '',
}) => {
  const [collapsableCtrl, setCollapsableCtrl] = useState(false);
  const buttonId = `${idBase}-dropdown-button`;
  const contentId = `${idBase}-dropdown-content`;

  useEffect(() => {
    if (alreadyOpen) setCollapsableCtrl(true);
  }, [alreadyOpen]);

  const handleExpandClick = () => {
    setCollapsableCtrl(!collapsableCtrl);
  };

  return (
    <div style={{ borderBottom: `2px solid black` }}>
      <StyledButtonGrid
        container
        alignItems={'center'}
        style={{ cursor: 'pointer' }}
        onClick={() => handleExpandClick()}
        component="button"
        id={buttonId}
        aria-haspopup="true"
        aria-controls={contentId}
        aria-expanded={collapsableCtrl}
      >
        <Grid item xs={labelGridXs}>
          <Typography margin={0} variant={'body2'}>
            {label}
          </Typography>
        </Grid>
        <Grid item xs={arrowGridXs} style={{ textAlign: 'right' }}>
          <IconButton
            disableFocusRipple
            disableTouchRipple
            disableRipple
            sx={{
              float: 'right',
              color: 'black !important',
              paddingRight: '0px !important',
            }}
            aria-haspopup="true"
            aria-expanded={collapsableCtrl ? false : true}
          >
            {collapsableCtrl ? (
              <ArrowDropUpIcon fontSize="small" color="inherit" />
            ) : (
              <ArrowDropDownIcon fontSize="small" color="inherit" />
            )}
          </IconButton>
        </Grid>
      </StyledButtonGrid>
      <Grid
        container
        component={'div'}
        id={contentId}
        aria-labelledby={buttonId}
      >
        <Collapse in={collapsableCtrl} style={{ ...collapseStyle }}>
          {hideWrapper ? (
            children
          ) : (
            <CollapseContent>{children}</CollapseContent>
          )}
        </Collapse>
      </Grid>
    </div>
  );
};
